import template from './privilege-template-save-confirmation-dialog.html';

export default class PrivilegeTemplateSaveConfirmationDialogComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-template-save-confirmation-dialog/privilege-template-save-confirmation-dialog-component.js